import { render, staticRenderFns } from "./ReportTableOEEByProduct.vue?vue&type=template&id=472c072f&"
import script from "./ReportTableOEEByProduct.vue?vue&type=script&lang=js&"
export * from "./ReportTableOEEByProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports